// Pill genérica (tons suaves) para Nível ONA, obrigatoriedade, filtros etc.
// Para status de avaliação/farol, use StatusBadge.
const TONES = {
  neutral: 'pill-neutral',
  dark: 'pill-dark',
  outline: 'pill-outline',
  success: 'pill-success',
  warning: 'pill-warning',
  danger: 'pill-danger',
};

export default function Pill({ tone = 'neutral', icon, children }) {
  return (
    <span className={`pill ${TONES[tone] || TONES.neutral}`}>
      {icon && <span className="ms" style={{ fontSize: 14 }}>{icon}</span>}
      {children}
    </span>
  );
}
